/** @format */

// ひらがな -> カタカナ
const ToKatakana = (str) =>
  str.replace(/[\u3041-\u3096]/g, (c) =>
    String.fromCharCode(c.charCodeAt(0) + 0x60)
  );

/**
 * マスタデータ処理
 */
class IndustryMaster {
  static search(master, text) {
    const findName = text.toUpperCase();
    const findKana = ToKatakana(text);
    let list = [];
    let groups = [];
    for (const group of master) {
      const part = group.list.reduce((a, c) => {
        if (c.name.toUpperCase().match(findName)) {
          a.push({ id: c.id, name: c.name, match: c.name });
        } else if (c.kana.match(findKana)) {
          a.push({ id: c.id, name: c.name, match: c.kana });
        }
        return a;
      }, []);
      if (part.length > 0) {
        groups.push({ name: group.name, list: part });
        list = list.concat(part.map((e) => e.match));
      }
    }
    return { groups, list };
  }
}

/**
 * 登録用データ管理
 */
class Industries {
  constructor(list) {
    this.data = list.reduce((a, industry) => {
      a[industry.industry_id] = {
        id: industry.industry_id,
        memo: industry.memo,
        checked: true,
      };
      return a;
    }, {});
  }

  update({ id, memo, checked }) {
    if (typeof id === "undefined") {
      return;
    }
    if (typeof this.data[id] === "undefined") {
      this.data[id] = { id, memo: "", checked: true };
    }
    if (typeof memo !== "undefined") {
      this.data[id].memo = memo;
    }
    if (typeof checked !== "undefined") {
      this.data[id].checked = checked;
    }
  }

  isChecked(id) {
    return this.data[id] ? this.data[id].checked : false;
  }

  hasChecked() {
    return !!Object.values(this.data).find((e) => e.checked);
  }

  getMemo(id) {
    return this.data[id] ? this.data[id].memo : "";
  }

  getCheckedGroup(master) {
    let ids = [];
    const func = (group) => {
      for (const industry of group.list) {
        const e = this.data[industry.id];
        if (e && e.checked) {
          return true;
        }
      }
      return false;
    };
    for (const group of master) {
      if (func(group)) {
        ids.push(group.id);
      }
    }
    return ids;
  }

  getPostData() {
    return Object.entries(this.data).reduce((a, [id, industry]) => {
      if (industry.checked) {
        a.push({ id, memo: industry.memo });
      }
      return a;
    }, []);
  }
}

class Occupations {
  constructor(list) {
    this.data = list.reduce((a, c) => {
      a[c] = true;
      return a;
    }, {});
  }

  isChecked(id) {
    return typeof this.data[id] !== "undefined" ? this.data[id] : false;
  }

  hasChecked() {
    return !!Object.values(this.data).find((e) => e);
  }

  update(id, checked) {
    if (typeof id === "undefined") {
      return;
    }
    if (typeof this.data[id] === "undefined") {
      this.data[id] = true;
    }
    if (typeof checked !== "undefined") {
      this.data[id] = checked;
    }
  }

  getCheckedGroup(master) {
    let ids = [];
    const func = (major) => {
      for (const minor of major.list) {
        for (const unit of minor.list) {
          if (this.data[unit.id]) {
            return true;
          }
        }
      }
      return false;
    };
    for (const major of master) {
      if (func(major)) {
        ids.push(major.id);
      }
    }
    return ids;
  }

  getPostData() {
    return Object.entries(this.data).reduce(
      (a, [id, valid]) => (valid ? (a.push(Number(id)), a) : a),
      []
    );
  }
}

export { IndustryMaster, Industries, Occupations };
